"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classNames = require("classnames");
var I18n = require("i18n-js");
var sanitized_render_1 = require("../../components/sanitized_render");
var core_link_1 = require("../../components/core_link");
exports.BUYING_GUIDE = 'buying_guide';
exports.BEST_SELLERS = 'best_sellers';
var MarketingCalloutCard = /** @class */ (function (_super) {
    tslib_1.__extends(MarketingCalloutCard, _super);
    function MarketingCalloutCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MarketingCalloutCard.prototype.hasTag = function () {
        return (this.props.pageType === exports.BUYING_GUIDE ||
            this.props.pageType === exports.BEST_SELLERS);
    };
    MarketingCalloutCard.prototype.getBackgroundImageStyle = function () {
        if (!this.props.imageURL)
            return null;
        return { backgroundImage: "url(" + this.props.imageURL + ")" };
    };
    MarketingCalloutCard.prototype.renderTag = function () {
        var p = this.props.pageType;
        return (React.createElement("p", { className: "marketing-callout__tag" },
            p === exports.BUYING_GUIDE && I18n.t('cms.marketingCallout.buyingGuideSubtitle'),
            p === exports.BEST_SELLERS && I18n.t('cms.marketingCallout.bestSellers')));
    };
    MarketingCalloutCard.prototype.renderSubtitle = function () {
        if (!this.props.subtitle)
            return;
        return (React.createElement(sanitized_render_1.default, { htmlTag: "h4", className: "marketing-callout__subtitle", html: this.props.subtitle, inlineTagsOnly: true, blacklistedTags: ['a'] }));
    };
    MarketingCalloutCard.prototype.renderPlaceholder = function () {
        var classes = classNames('marketing-callout', 'marketing-callout--placeholder', { 'marketing-callout--wide': this.props.wideCard });
        return (React.createElement("div", { className: classes },
            React.createElement("div", { className: "marketing-callout__text-area" },
                React.createElement("div", { className: "marketing-callout__text" },
                    React.createElement("div", { className: "marketing-callout__title" })))));
    };
    MarketingCalloutCard.prototype.render = function () {
        var classes = classNames('marketing-callout', { 'marketing-callout--with-tag': this.hasTag() }, { 'marketing-callout--wide': this.props.wideCard }, { 'marketing-callout--square': this.props.squareImage }, { 'marketing-callout--lp': this.props.channel === 'lp' }, { 'marketing-callout--core': this.props.channel === 'core' });
        if (!this.props.targetHref)
            return this.renderPlaceholder();
        return (React.createElement("div", { className: classes },
            React.createElement(core_link_1.default, { className: "marketing-callout__inner", to: this.props.targetHref },
                React.createElement("div", { className: "marketing-callout__image-area" },
                    React.createElement("div", { className: "marketing-callout__image", style: this.getBackgroundImageStyle() })),
                React.createElement("div", { className: "marketing-callout__text-area" },
                    React.createElement("div", { className: "marketing-callout__text" },
                        this.hasTag() ? this.renderTag() : this.renderSubtitle(),
                        React.createElement(sanitized_render_1.default, { htmlTag: "h4", className: "marketing-callout__title", html: this.props.title, inlineTagsOnly: true, blacklistedTags: ['a'] }))))));
    };
    return MarketingCalloutCard;
}(React.Component));
exports.default = MarketingCalloutCard;
//# sourceMappingURL=marketing_callout_card.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/cms/components/marketing_callout_card.js
// module id = 6GJf
// module chunks = 20 21